
const BoldText:React.FC<{text:string | undefined}> = ({text}) => {
   return(
    <> 
       <div className='text-left' style={{fontSize:'14px', fontWeight:'600'}}>{text}</div>
    </>
   )
}
export default BoldText